import { helpers } from 'vuelidate/lib/validators'

export const decimalWeight = helpers.regex('decimalWeight', /^\d{0,5}(\.\d{1,5})?$/)
export const alphaNumeric = helpers.regex('alphaNumeric', /(?=.*[a-zA-Z])(?=.*[0-9])/)
export const upperAndLowerCases = helpers.regex('upperAndLowerCases', /(?=.*[a-z])(?=.*[A-Z])/)
export const specialCharacters = helpers.regex('specialCharacters', /(?=.*[?=.\-+_~'@!$#%&*^"|(),/\\:;<>[\]{}\s])/)

export const cpf = (value) => {
    const cpf = value.match(/[0-9]/g) || []

    if (cpf.length !== 11) return false

    let numberArr = cpf.slice(0, 9).map((n) => parseInt(n))

    if ([...new Set(numberArr)].length === 1) return false

    const firstDigit = calcDigit(numberArr)
    numberArr = [...numberArr, firstDigit]
    const secondDigit = calcDigit(numberArr)
    numberArr = [...numberArr, secondDigit]

    return numberArr.join('') === cpf.join('')
}
const calcDigit = (numberArr) => {
    const multiplier = numberArr.length === 9 ? 10 : 11
    const sum = numberArr.reduce((sum, n, i) => sum + n * (multiplier - i), 0)
    const remainder = sum % 11
    return remainder <= 1 ? 0 : 11 - remainder
}

export const smallerOrBigger = (option) => {
    const smallerIsBetter = '0'
    const biggerIsBetter = '1'
    const { value } = option
    return value === smallerIsBetter || value === biggerIsBetter
}

export const manualOrAutomatic = (option) => {
    const manual = '0'
    const automatic = '1'
    const { value } = option
    return value === manual || value === automatic
}

export const checkinOrProgress = (option) => {
    const checkin = '0'
    const progress = '1'
    const { value } = option
    return value === checkin || value === progress
}

export const groupLevel = (option) => {
    if (!option) {
        return true
    }
    const levels = ['department', 'personal', 'unit']
    const { value } = option
    return levels.includes(value)
}

export const checkInsFrequency = (option) => {
    if (!option) {
        return true
    }
    const frequencies = ['monthly']
    const { value } = option
    return frequencies.includes(value)
}

export const validFormula = (expression) => {
    if (expression === '' || expression == null) {
        return true
    }

    try {
        const formula = expression.replace(/[[\]]/g, '')
        return typeof eval(formula) === 'number'
    } catch (e) {
        return false
    }
}
